import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {map, Observable} from "rxjs";
import {Constat} from "../shared/interfaces/Constat";
import JSZip from "jszip";

@Injectable({
  providedIn: 'root'
})
export class FileService {
  private readonly apiUrl = environment.apiUrl;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/zip'
    })
  };

  constructor(private http: HttpClient) {
  }

  getFilesByConstatId(constatId: string): Observable<Promise<JSZip>> {
    const url = `${this.apiUrl}/pad/constats/EDL/${constatId}/fichiers`;
    return this.http.get(url, {responseType: 'arraybuffer'}).pipe(
      map((data: ArrayBuffer) => {
        return JSZip.loadAsync(data);
      })
    );
  }

  getPhotoUrl(photo: any) {
    if (!photo) return

    // 1. If we have base64 data, use it. This is persistent.
    if (photo.base64) {
      // Ensure it has the proper data URI prefix if it doesn't already
      return photo.base64.startsWith('data:image')
        ? photo.base64
        : `data:image/jpeg;base64,${photo.base64}`;
    }

    return photo.previewUrl || '';
  }


}
